import React from 'react';
import { toast } from 'sonner';
import { api } from '../../services/api';
import { extractApiError } from '../../utils/pdfDownload';

interface HistoryBatch {
  id: string;
  batch_name: string;
  planned_delivery_date: string;
  status: string;
  is_archived?: boolean;
  total_stops?: number;
}

interface TourHistoryListProps {
  batches: HistoryBatch[];
  onOpen: (id: string) => void;
  onChanged: () => void;
}

export const TourHistoryList: React.FC<TourHistoryListProps> = ({
  batches,
  onOpen,
  onChanged,
}) => {
  const archive = async (id: string, archived: boolean) => {
    try {
      await api.put(
        `/delivery-batches/${id}/${archived ? 'unarchive' : 'archive'}`
      );
      onChanged();
    } catch (err) {
      toast.error(extractApiError(err).message);
    }
  };

  const remove = async (id: string) => {
    try {
      await api.delete(`/delivery-batches/${id}`);
      toast.success('Tour deleted');
      onChanged();
    } catch (err) {
      toast.error(extractApiError(err).message);
    }
  };

  if (batches.length === 0) {
    return (
      <p className="text-sm text-gray-500 py-8 text-center">No past tours</p>
    );
  }

  return (
    <ul className="space-y-2">
      {batches.map((batch) => (
        <li
          key={batch.id}
          className="bg-white rounded-2xl border border-gray-100 p-3 flex items-center gap-3"
        >
          <button
            type="button"
            onClick={() => onOpen(batch.id)}
            className="flex-1 min-w-0 text-left"
          >
            <p className="font-black text-gray-900 truncate">{batch.batch_name}</p>
            <p className="text-xs text-gray-500">
              {batch.planned_delivery_date} · {batch.status}
            </p>
          </button>
          <button
            type="button"
            onClick={() => void archive(batch.id, Boolean(batch.is_archived))}
            className="text-xs font-bold text-gray-500"
          >
            {batch.is_archived ? 'Unarchive' : 'Archive'}
          </button>
          <button
            type="button"
            onClick={() => void remove(batch.id)}
            className="text-xs font-bold text-red-600"
          >
            Delete
          </button>
        </li>
      ))}
    </ul>
  );
};
